import * as React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import { ApiRegisterVerify, ServerResponse } from '../../api';
import Footer from '../../components/footer/Footer';
import HeaderLoggedOut from '../../components/headerLoggedOut/HeaderLoggedOut';
import './RegistrationResult.css';

interface RegistrationActivationProps {
    match: { params: { token: string } };
}

interface RegistrationActivationState {
    serverResponse: ServerResponse | undefined;
    loading: boolean;
}

export default class RegistrationResult extends React.PureComponent<
    RegistrationActivationProps,
    RegistrationActivationState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            loading: true,
            serverResponse: undefined,
        };
    }

    public componentDidMount() {
        ApiRegisterVerify({ Token: this.props.match.params.token }, (sr: ServerResponse) => {
            this.setState({ serverResponse: sr, loading: false });
        });
    }

    public render() {
        const registrationActivated = this.state.serverResponse && this.state.serverResponse.OK;

        return (
            <>
                <HeaderLoggedOut />
                <Container id="registrationResultView" className="text-center">
                    {!this.state.loading && (
                        <>
                            {registrationActivated && this.renderSuccess()}
                            {!registrationActivated && this.renderFailure()}
                        </>
                    )}
                </Container>
                <Footer />
            </>
        );
    }

    private renderSuccess() {
        return (
            <>
                <Row>
                    <Col>
                        <h3>{TR.registrationResult_success}</h3>
                    </Col>
                </Row>
                <Row>
                    <Col md={6} className="offset-md-3">
                        {TR.registrationResult_login}
                        <br />
                        <Link to="/" className="btn mt-4">
                            {TR.registrationResult_login2}
                        </Link>
                    </Col>
                </Row>
            </>
        );
    }

    private renderFailure() {
        return (
            <>
                <Row>
                    <Col>
                        <h3>{TR.registrationResult_failed}</h3>
                    </Col>
                </Row>
                <Row>
                    <Col md={8} className="offset-md-2">
                        <ol style={{ listStyleType: 'none', paddingLeft: 0 }}>
                            <li>{TR.registrationResult_failed_because}</li>
                            <br />
                            <li>{TR.registrationResult_timeout}</li>
                            <br />
                            <li>{TR.registrationResult_only_once}</li>
                            <br />
                            <li>{TR.registrationResult_missing_char}</li>
                        </ol>
                        <br />
                        <Link to="/registration" className="btn mt-4">
                            {TR.registrationResult_to_registration}
                        </Link>
                    </Col>
                </Row>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/registrationResult/RegistrationResult.tsx